import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import {
  extractRouteParams,
  getRoutePath,
  RouteTargetingBidderExisting,
} from '~/src/dash/router/routes';
import {
  TargetingPresetCategory,
  TargetingPresetParameters,
  TargetingPresetParamKey,
  TargetingPresetParamKeys,
} from '~/src/dash/views/tools/TargetingPresets/bidder-targeting/config';

export const getBidderTargetingEditRoute = (
  presetID: number,
  session: ISessionState,
  user: IUserState,
): string => {
  const test = getRoutePath(RouteTargetingBidderExisting, extractRouteParams({ session, user }), {
    targetingbidderid: presetID,
  });
  return test;
};

export const optionKeys: TargetingPresetParamKey[] = [
  // INVENTORY
  // TargetingPresetParamKeys.CHANNELS,
  // TargetingPresetParamKeys.CHANNEL_GROUPS,
  // TargetingPresetParamKeys.CHANNEL_LISTS,
  TargetingPresetParamKeys.SLOTS,
  TargetingPresetParamKeys.ENFORCE_SLOT_TARGETING,
  TargetingPresetParamKeys.POSITION,
  TargetingPresetParamKeys.POD_SEQUENCE,
  TargetingPresetParamKeys.REQUESTED_POD_DURATION,
  TargetingPresetParamKeys.COMBINE_VMAP_REQUESTS, // DB: AdbreakTargeting
  TargetingPresetParamKeys.AD_BREAK, // DB: TargetedAdBreak
  TargetingPresetParamKeys.GIVN_TARGETING,
  // CONTENT
  TargetingPresetParamKeys.CONTENT_CHANNEL,
  TargetingPresetParamKeys.CONTENT_DISTRIBUTOR,
  TargetingPresetParamKeys.CONTENT_GENRE,
  TargetingPresetParamKeys.CONTENT_ID,
  TargetingPresetParamKeys.CONTENT_NETWORK,
  TargetingPresetParamKeys.CONTENT_PRODUCER,
  TargetingPresetParamKeys.CONTENT_RATING,
  TargetingPresetParamKeys.CONTENT_SERIES,
  TargetingPresetParamKeys.CONTENT_TITLE,
  TargetingPresetParamKeys.CONTENT_CATEGORY,
  // GEO
  TargetingPresetParamKeys.TARGETED_REGIONS, // aka COUNTRY GROUPS
  TargetingPresetParamKeys.TARGETED_COUNTRIES,
  TargetingPresetParamKeys.LOCAL_TARGETING,
  // DAYPARTING
  TargetingPresetParamKeys.DAYPARTING,
  // PRIVACY
  TargetingPresetParamKeys.COPPA,
  TargetingPresetParamKeys.LIMITED_AD_TRACKING,
  TargetingPresetParamKeys.CCPA,
  // CUSTOM
  TargetingPresetParamKeys.CUSTOM_4,
  TargetingPresetParamKeys.CUSTOM_5,
  TargetingPresetParamKeys.CUSTOM_6,
  TargetingPresetParamKeys.CUSTOM_7,
  TargetingPresetParamKeys.CUSTOM_8,
  TargetingPresetParamKeys.CUSTOM_9,
  TargetingPresetParamKeys.CUSTOM_10,
  TargetingPresetParamKeys.CUSTOM_11,
  TargetingPresetParamKeys.CUSTOM_12,
  TargetingPresetParamKeys.CUSTOM_13,
  TargetingPresetParamKeys.CUSTOM_14,
  TargetingPresetParamKeys.CUSTOM_15,
  TargetingPresetParamKeys.CUSTOM_16,
  TargetingPresetParamKeys.CUSTOM_17,
  TargetingPresetParamKeys.CUSTOM_18,
  TargetingPresetParamKeys.CUSTOM_TARGETING,
  // DEVICE
  TargetingPresetParamKeys.TARGETED_DEVICES,
  TargetingPresetParamKeys.TARGETED_DEVICE_TYPES,
  TargetingPresetParamKeys.TARGETED_DEVICE_SUBTYPES,
  TargetingPresetParamKeys.IP_FILTERS,
  // APP
  TargetingPresetParamKeys.APP_BUNDLE_IDS,
  // DEALS
  TargetingPresetParamKeys.DEAL_IDS,
  TargetingPresetParamKeys.FREEWHEEL_SECTION_IDS,
  // STREAMS
  TargetingPresetParamKeys.TARGETED_LIVESTREAMS,
  // SEGMENTS
  TargetingPresetParamKeys.AUDIENCE_SEGMENTS,
  TargetingPresetParamKeys.CONTEXTUAL_SEGMENTS,
  // SITE PAGES
  TargetingPresetParamKeys.SITE_PAGES,
  // SITE DOMAINS
  TargetingPresetParamKeys.SITE_DOMAINS,
];

export const generateTargetingPresetParameterOptions = (
  publisherID: string,
  isSuperUser: boolean,
) => {
  const options: any[] = [];
  let currentCategory = '' as TargetingPresetCategory;
  optionKeys.forEach((key) => {
    const { label, categoryKey, isSuperUserOnly, checkIfHidden } = TargetingPresetParameters[key];
    if (categoryKey !== currentCategory) {
      currentCategory = categoryKey;
      options.push({
        key: categoryKey,
        label: categoryKey,
        isCategory: true,
        category: categoryKey,
      });
    }
    if (isSuperUserOnly && !isSuperUser) return;
    if (checkIfHidden && checkIfHidden(publisherID, isSuperUser)) return;
    options.push({
      key,
      label,
      category: categoryKey,
    });
  });
  return options;
};
